import { render, staticRenderFns } from "./MenuCompras.vue?vue&type=template&id=709ae89c&scoped=true&"
import script from "./MenuCompras.vue?vue&type=script&lang=js&"
export * from "./MenuCompras.vue?vue&type=script&lang=js&"
import style0 from "./MenuCompras.vue?vue&type=style&index=0&id=709ae89c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709ae89c",
  null
  
)

export default component.exports